import { useState, useEffect } from "react";
import moment from "moment";
import Pagination from "../../components/Pagination";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import { useAllTicketsHooks } from "../../utils/ticket/TicketUlits";
import ModalReportTicketing from "../../components/ticketing/ModalReportTicketing";
import ModalDownloadTickets from "../../components/ticketing/ModalDownloadTickets";
import useRegionHooks from "../../utils/RegionHooks";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import ModalReportFollowupTicketing from "../../components/ticketing/ModalReportFollowupTicketing";

export default function TicketingPage() {
  let { hasAccess } = useControlPermission();
  let regionFilter = useRegionHooks();
  const { projects } = useGroupListHooks();

  let [formFilter, setFormFilter] = useState({
    q: "",
    role: "",
    type: "",
    status: "",
    project_id: "",
  });
  let [filter, setFilter] = useState({
    q: "",
    role: "",
    status: "",
    province: "",
    kota_kab: "",
    kecamatan: "",
    kelurahan: "",
    project_id: "",
    page: 1,
    page_size: 10,
  });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const [selectedId, setSelectedId] = useState("");
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [showModalDownload, setShowModalDownload] = useState(false);
  const [showModalFollowUp, setShowModalFollowUp] = useState(false);

  const { data, fetchTickets, meta, loading } = useAllTicketsHooks({ filter });

  const toggleModalTicket = (id) => {
    setSelectedId(id);
    setShowModalTicket(true);
  };

  const toggleModalFollowUp = (id) => {
    setSelectedId(id);
    setShowModalFollowUp(true);
  };

  useEffect(() => {
    fetchTickets(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const gotoPage = (page) => {
    setFilter({ ...filter, page: page });
  };

  const toggleModalDownload = () => {
    setShowModalDownload(!showModalDownload);
  };

  const onSuccess = (message) => {
    fetchTickets(filter);
    setAlert({ show: true, message: message, type: "success" });
  };

  function applyFilter() {
    let form_filter = { ...filter, ...formFilter, page: 1 };
    form_filter.province = regionFilter.province;
    form_filter.kota_kab = regionFilter.city;
    form_filter.kecamatan = regionFilter.district;
    form_filter.kelurahan = regionFilter.addressId;
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({ q: "", role: "", status: "", project_id: "" });
    setFilter({
      q: "",
      role: "",
      status: "",
      province: "",
      kota_kab: "",
      kecamatan: "",
      kelurahan: "",
      project_id: "",
      page: 1,
      page_size: 10,
    });
    regionFilter.resetRegion();
  };

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  return (
    <MainLayout resource_key="ticket">
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col">
            <h1 className="h3 mb-0 text-gray-800">Tiket Bantuan</h1>
          </div>
          <div className="col-auto">
            {hasAccess("export-ticket") && (
              <button className="btn btn-primary" onClick={() => toggleModalDownload()}>
                <i className="fas fa-download"></i> Unduh Data Tiket
              </button>
            )}
          </div>
        </div>

        <Box title="Daftar Tiket" loading={loading}>
          <div className="mb-4">
            <div className="row">
              <div className="col-sm-2">
                <div className="form-group">
                  <label>Pencarian</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formFilter.q}
                    onChange={(event) => changeFilter("q", event.target.value)}
                    placeholder="No. Registrasi / No. Tiket / Nama / No. Hape"
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="status">Status</label>
                  <select
                    type="text"
                    name="status"
                    value={formFilter.status}
                    onChange={(event) => changeFilter("status", event.target.value)}
                    className="form-control"
                    id="status"
                  >
                    <option value="">Default</option>
                    <option value="open">Open</option>
                    <option value="working">Working</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="province_filter">Provinsi</label>
                  <select
                    className="form-control"
                    id="province_filter"
                    value={regionFilter.province}
                    onChange={(event) => regionFilter.changeProvince(event.target.value)}
                  >
                    <option value="">-- Provinsi --</option>
                    {regionFilter.provinces.map((province, index) => (
                      <option key={index} value={province.province}>
                        {province.province}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="kab_filter">Kabupaten/Kota</label>
                  <select
                    className="form-control"
                    id="kab_filter"
                    value={regionFilter.city}
                    onChange={(event) => regionFilter.changeCity(event.target.value)}
                  >
                    <option value="">-- Kabupaten/Kota --</option>
                    {regionFilter.cities.map((city, index) => (
                      <option key={index} value={city.kota_kab}>
                        {city.kota_kab}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="kecamatan_filter">Kecamatan</label>
                  <select
                    className="form-control"
                    id="kecamatan_filter"
                    value={regionFilter.district}
                    onChange={(event) => regionFilter.changeDistrict(event.target.value)}
                  >
                    <option value="">-- Kecamatan --</option>
                    {regionFilter.districts.map((district, index) => (
                      <option key={index} value={district.kecamatan}>
                        {district.kecamatan}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="kelurahan_filter">Kelurahan</label>
                  <select
                    className="form-control"
                    id="kelurahan_filter"
                    value={regionFilter.addressId}
                    onChange={(event) => regionFilter.setAddressId(event.target.value)}
                  >
                    <option value="">-- Kelurahan --</option>
                    {regionFilter.addresslist.map((kelurahan, index) => (
                      <option key={index} value={kelurahan.kelurahan}>
                        {kelurahan.kelurahan}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="role">Tipe</label>
                  <select
                    name="type"
                    value={formFilter.type}
                    onChange={(event) => changeFilter("type", event.target.value)}
                    className="form-control"
                    id="type"
                  >
                    <option value="">Semua</option>
                    <option value="follow-up">Follow Up</option>
                    <option value="technical">Technical</option>
                    <option value="marketing">Marketing</option>
                    <option value="billing">Billing</option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="role">Penugasan</label>
                  <select
                    name="role"
                    value={formFilter.role}
                    onChange={(event) => changeFilter("role", event.target.value)}
                    className="form-control"
                    id="role"
                  >
                    <option value="">Semua Divisi </option>
                    <option value="cs">CS</option>
                    <option value="noc">NOC</option>
                    <option value="technician">Technician</option>
                    <option value="sales">Sales</option>
                    <option value="finance">Finance</option>
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="projectFilter">Grup/Project</label>
                  <select
                    className="form-control"
                    id="projectFilter"
                    value={formFilter.project_id}
                    onChange={(event) => changeFilter("project_id", event.target.value)}
                  >
                    <option value="">SEMUA</option>
                    {projects.map((project, index) => (
                      <option value={project.id} key={index}>
                        {project.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-auto">
                <div className="form-group">
                  <button
                    className="btn btn-primary"
                    onClick={() => applyFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Filter
                  </button>
                  <button
                    className="btn btn-default"
                    onClick={() => resetFilter()}
                    style={{ marginTop: "32px" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          <AlertBox {...alert} setAlert={setAlert} />
          <div style={{ overflowX: "auto" }}>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>No. Tiket</th>
                  <th>Tanggal Masuk</th>
                  <th>Durasi</th>
                  <th>Nama</th>
                  <th>Alamat</th>
                  <th>Project</th>
                  <th>Telepon</th>
                  <th>Tipe</th>
                  <th>Status</th>
                  <th>Prioritas</th>
                  <th>Tugaskan ke</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 && (
                  <tr>
                    <td colSpan={11} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                )}
                {data.map((ticket, index) => (
                  <tr key={index}>
                    <td>
                      {ticket.type === "follow-up" ? (
                        <button
                          className="btn btn-block text-nowrap btn-sm btn-custom-orange"
                          onClick={() => toggleModalFollowUp(ticket.id)}
                        >
                          <i className="fas fa-file-pen"></i>{" "}
                          {ticket.status === "closed" ? "Detail" : "Update"} Follow Up
                        </button>
                      ) : (
                        <button
                          className="btn btn-block text-nowrap btn-sm btn-primary"
                          onClick={() => toggleModalTicket(ticket.id)}
                        >
                          <i className="fas fa-ticket-alt"></i>{" "}
                          {ticket.status === "closed" ? "Detail" : "Update"} Tiket
                        </button>
                      )}
                    </td>
                    <td>{ticket.ticket_number}</td>
                    <td>{moment.unix(ticket.createdAt).format("DD MMMM YYYY - HH:mm")}</td>
                    <td>{ticket.total_time}</td>
                    <td>{ticket.name}</td>
                    <td>
                      {ticket.customer.installation_address.address +
                        " RT " +
                        ticket.customer.installation_address.rt +
                        "/RW " +
                        ticket.customer.installation_address.rw +
                        ", " +
                        ticket.customer.installation_address.addresses.kelurahan +
                        ", " +
                        ticket.customer.installation_address.addresses.kecamatan +
                        ", " +
                        ticket.customer.installation_address.addresses.kota_kab +
                        ", " +
                        ticket.customer.installation_address.addresses.province +
                        ", " +
                        ticket.customer.installation_address.addresses.postal_code}
                    </td>
                    <td>{ticket.customer.project?.name || "-"}</td>
                    <td>{ticket.phone_number}</td>
                    <td>{ticket.type}</td>
                    <td>
                      {ticket.status === "open" && (
                        <span className="badge badge-success">open</span>
                      )}
                      {ticket.status === "working" && (
                        <span className="badge badge-warning">working</span>
                      )}
                      {ticket.status === "closed" && (
                        <span className="badge badge-secondary">closed</span>
                      )}
                    </td>
                    <td>
                      {ticket.priority === "low" && <span className="badge badge-info">Low</span>}
                      {ticket.priority === "medium" && (
                        <span className="badge badge-warning">Medium</span>
                      )}
                      {ticket.priority === "high" && (
                        <span className="badge badge-danger">High</span>
                      )}
                    </td>
                    <td>{ticket.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {meta.count > meta.page_size && (
            <Pagination
              totalpage={Math.ceil(meta.count / meta.page_size)}
              selectedpage={meta.page}
              clickpage={(page) => gotoPage(page)}
              next={() => gotoPage(meta.page + 1)}
              prev={() => gotoPage(meta.page - 1)}
            />
          )}
        </Box>
      </div>

      <ModalReportTicketing
        show={showModalTicket}
        id={showModalTicket ? selectedId : ""}
        onClose={() => setShowModalTicket(false)}
        onSuccess={onSuccess}
      />
      <ModalDownloadTickets
        show={showModalDownload}
        onClose={() => setShowModalDownload(false)}
        onSuccess={onSuccess}
      />
      <ModalReportFollowupTicketing
        show={showModalFollowUp}
        id={showModalFollowUp ? selectedId : ""}
        onClose={() => setShowModalFollowUp(false)}
        onSuccess={onSuccess}
      />
    </MainLayout>
  );
}
